import type {
  AdminDocumentStatus,
  AdminRegistrationStatus,
  TeamMemberStatus,
  TeamStatus,
  VoucherState,
} from '@gg/shared';

export type Tone = 'accent' | 'neutral' | 'success' | 'danger';

export const registrationStatusTone = (s: AdminRegistrationStatus | 'failed'): Tone =>
  s === 'paid' ? 'success' : s === 'pending' ? 'neutral' : 'danger';

export const documentStatusTone = (s: AdminDocumentStatus): Tone =>
  s === 'approved'
    ? 'success'
    : s === 'rejected' || s === 'expired'
      ? 'danger'
      : s === 'pending'
        ? 'accent'
        : 'neutral';

export const formatStatusTone = (s: 'draft' | 'open' | 'closed' | 'sold_out'): Tone =>
  s === 'open' ? 'success' : s === 'draft' ? 'neutral' : 'danger';

export const voucherStateTone = (s: VoucherState): Tone =>
  s === 'active' ? 'success' : s === 'scheduled' ? 'neutral' : 'danger';

export const teamStatusTone = (s: TeamStatus): Tone =>
  s === 'complete' ? 'success' : s === 'forming' ? 'neutral' : 'danger';

export const teamMemberStatusTone = (s: TeamMemberStatus): Tone =>
  s === 'joined' ? 'success' : s === 'invited' ? 'accent' : 'neutral';
